import React from "react";
import Banner from "../../components/Banner/Banner";
import BannerBottom from "../../components/Banner/BannerBottom";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import NewArrivals from "../../components/home/NewArrivals/NewArrivals";
import Sale from "../../components/home/Sale/Sale";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import YearProduct from "../../components/home/YearProduct/YearProduct";
import usePageMeta from "../../utils/usePageMeta";

const Home = () => {
  usePageMeta({
    title: "MD Wedding Props | Wedding Decor and Event Props",
    description:
      "Browse curated wedding props, decor, and event essentials for stunning ceremonies and receptions.",
    keywords:
      "wedding props, wedding decor, event props, ceremony decor, reception decor",
  });

  return (
    <div className="w-full mx-auto">
      <Banner />
      <BannerBottom />
      <div className="max-w-container mx-auto px-4">
        <Sale />
        <NewArrivals />
        <BestSellers />
        <YearProduct />
        <SpecialOffers />
      </div>
    </div>
  );
};

export default Home;
